import apiClient from './apiClient';
import { API_ENDPOINTS } from '../config/apiConfig';
import { DashboardDefaultsDto, DashboardDefaultsUpdateDto } from '../types/DashboardSettings';

export const DEFAULT_LOW_STORAGE_TRIGGER_PERCENT = 80;

export const getDashboardDefaults = async (): Promise<DashboardDefaultsDto> => {
  const response = await apiClient.get<DashboardDefaultsDto>(API_ENDPOINTS.SETTINGS.DASHBOARD_DEFAULTS);
  return response.data;
};

export const updateDashboardDefaults = async (
  request: DashboardDefaultsUpdateDto
): Promise<DashboardDefaultsDto> => {
  const response = await apiClient.put<DashboardDefaultsDto>(API_ENDPOINTS.SETTINGS.DASHBOARD_DEFAULTS, request);
  return response.data;
};
